module.exports = __webpack_public_path__ + "ba1251b446947524a2148e1bee62132a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_small_x1_variable/public/news/img1.jpg
// module id = 423
// module chunks = 0